export enum LoginName {
  Local = 'local',
  Feide = 'feide',
}
